import type { ReactNode } from "react";

/** Shared heading and spacing for product information in the General tabs. */
export default function ProductDataSection({ title, children }: { title: string; children?: ReactNode }) {
  return <div>
    <div style={{ marginTop: "10px", backgroundColor: "var(--backgroundColorGrey)", color: "var(--white1)", padding: "5px" }}>
      &nbsp;{title}<br />
    </div>
    {children}
  </div>;
}
